import pickBy from 'lodash.pickby'

import validatePresence from './validatePresence'

function stripEmptyValues(values) {
  return pickBy(values, validatePresence)
}

export default stripEmptyValues
